import { PrimariaApi } from "@uxland/primary-shell";
import { ActivityHistoryImporter } from "./activity-history-item/importer/activity-history-importer";
import { ActivityHistoryMain } from "./activity-history-item/list/UI/main-view/activity-history-main";
import { container } from "./infrastructure/ioc/container";
import { TYPES } from "./infrastructure/ioc/types";

const IMPORTER_VIEW_ID = "activity-history-importer";

export const registerViews = (api: PrimariaApi) => {
  api.regionManager.registerView(api.regionManager.regions.clinicalMonitoring.content, {
    id: api.pluginInfo.pluginId,
    factory: () => Promise.resolve(new ActivityHistoryMain()),
  });

  api.regionManager.registerView(api.regionManager.regions.shell.importDataActivityHistory, {
    id: IMPORTER_VIEW_ID,
    factory: () => Promise.resolve(new ActivityHistoryImporter()),
    sortHint: "0020",
  });
};

export const unregisterViews = () => {
  const api = container.get(TYPES.primaryApi) as PrimariaApi;
  api.regionManager.removeView(api.regionManager.regions.clinicalMonitoring.content, api.pluginInfo.pluginId);
  api.regionManager.removeView(api.regionManager.regions.shell.importDataActivityHistory, IMPORTER_VIEW_ID);
};
